import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { privateCompanyDefaultFolderTemplatesManager } from '@inpart-io/padme-iap';
import { type IDefaultFolderTemplate } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_COMPANY_DEFAULT_FOLDER_TEMPLATE_MODULE = 'privatecompanydefaultfoldertemplates';

const dataObjectModule = getDataObjectsModule<IDefaultFolderTemplate>(privateCompanyDefaultFolderTemplatesManager, 3);
const searchModule = getSearchModule<IDefaultFolderTemplate>(privateCompanyDefaultFolderTemplatesManager);

const privateCompanyDefaultFolderTemplateModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_COMPANY_DEFAULT_FOLDER_TEMPLATE_MODULE, privateCompanyDefaultFolderTemplateModuleInstance);

export { PRIVATE_COMPANY_DEFAULT_FOLDER_TEMPLATE_MODULE };
